import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import { MapComponent } from "../MapComponent";
import { SelectComponent } from "components/SelectMenu/SelectComponent";
import { useDispatch, useSelector } from "react-redux";
import RegularButton from "components/CustomButtons/Button";
import Snackbar from "components/Snackbar/Snackbar";
import { typesUnitsOpt } from "helpers/dictionary";
import { animations } from "helpers/animations";
import { blue } from "@material-ui/core/colors";
import { useCustomerForm } from "./hooks";
import { useHandleView } from "../useHandleView";
import { useSearch } from "hooks/useSearch";
import { selectCustomerAccount } from "redux/actions/customers/customersAction";
import { isWholesalerOptions } from "./inputValues";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { PERMISSIONS } from "router/permissions";

export const CustomerForm = ({ searchInput, onClose, handlePhone = false }) => {
  const dispatch = useDispatch();
  const {
    addMode,
    newCustomerMode,
    editCustomer,
    stationsAvailable,
  } = useSelector(({ customersReducer }) => customersReducer);
  const { color, message, isOpen, isLoadingComp } = useSelector(
    ({ search }) => search
  );
  const { rules } = useSelector(({ login }) => login);
  const { clearSnackbar } = useSearch();

  const isGiro = rules.includes(PERMISSIONS.CUSTOMER_GIRO);
  const isWebVerify = rules.includes(PERMISSIONS.ACCOUNT_WEB_VERIFY);
  const cancel = useHandleView(0);

  const cancelAction = () => {
    cancel();
    dispatch(selectCustomerAccount(null));
  };

  const {
    handleSearchAddress,
    setLocation,
    location,
    handleUnitType,
    handleSubmit,
    values,
    handleInputOnChange,
    checkboxOnChange,
    handleNewValues,
    fieldErrors,
    createFactorOpt,
  } = useCustomerForm(searchInput, onClose, handlePhone);

  const {
    name,
    rfc,
    isWholesaler,
    phone,
    street,
    extNumber,
    intNumber,
    colony,
    municipality,
    postalCode,
    state,
    reference,
    idStation,
    type,
    segment,
    segmentsOpt,
    subsegment,
    factor,
    isVerified,
  } = values;

  const factorOpt = createFactorOpt();

  return (
    <FormControl fullWidth className={animations.fadeIn}>
      {editCustomer && (
        <FormLabel
          style={{
            transition: ".2s ease",
            marginBottom: 8,
            color: blue[500],
          }}
        >
          <Typography variant="subtitle2">Editar Cliente</Typography>
        </FormLabel>
      )}
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Nombre"
            name="name"
            value={name}
            onChange={handleInputOnChange}
            variant="outlined"
            autoFocus
            error={fieldErrors.name}
            helperText={fieldErrors.name || ""}
          />
        </Grid>
        {newCustomerMode && (
          <Grid
            item
            xs={12}
            sm={rules.includes("CUSTOMERS-WHOLESALER") ? 4 : 6}
          >
            <TextField
              fullWidth
              label="RFC"
              name="rfc"
              value={rfc}
              onChange={handleInputOnChange}
              variant="outlined"
              error={fieldErrors.rfc}
              helperText={fieldErrors.rfc || ""}
            />
          </Grid>
        )}
        {editCustomer && (
          <Grid
            item
            xs={12}
            sm={rules.includes("CUSTOMERS-WHOLESALER") ? 4 : 6}
          >
            <TextField
              fullWidth
              label="RFC"
              name="rfc"
              value={rfc}
              onChange={handleInputOnChange}
              variant="outlined"
              error={fieldErrors.rfc}
              helperText={fieldErrors.rfc || ""}
            />
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={
            newCustomerMode || editCustomer
              ? rules.includes("CUSTOMERS-WHOLESALER")
                ? 4
                : 6
              : 9
          }
        >
          <TextField
            fullWidth
            label="Telefono"
            name="phone"
            value={phone}
            onChange={handleInputOnChange}
            variant="outlined"
            error={fieldErrors.phone}
            helperText={fieldErrors.phone || ""}
          />
        </Grid>
        {!newCustomerMode && !editCustomer && (
          <Grid item xs={12} sm={3} style={{ display: "flex", alignItems: "center" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!isVerified}
                  onChange={checkboxOnChange}
                  name="isVerified"
                  color="primary"
                  disabled={!isWebVerify || !!isVerified}
                />
              }
              label="Verificado"
            />
          </Grid>
        )}

        {rules.includes("CUSTOMERS-WHOLESALER") &&
          (newCustomerMode || editCustomer) && (
            <Grid item xs={12} sm={newCustomerMode || editCustomer ? 4 : 6}>
              <SelectComponent
                label="Cliente"
                name="isWholesaler"
                value={isWholesaler}
                onChange={handleInputOnChange}
                options={isWholesalerOptions}
                defaultValue="Seleccione un tipo"
              />
            </Grid>
          )}

        <Grid item xs={12} sm={12}>
          <MapComponent
            getAddress={handleSearchAddress}
            location={location}
            handleLocation={setLocation}
            type={type}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Calle"
                name="street"
                value={street}
                onChange={handleInputOnChange}
                variant="outlined"
                error={fieldErrors.street}
                helperText={fieldErrors.street || ""}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="No Exterior"
                name="extNumber"
                value={extNumber}
                onChange={handleInputOnChange}
                variant="outlined"
                error={!!fieldErrors.extNumber}
                helperText={fieldErrors.extNumber}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="No Interior"
                name="intNumber"
                value={intNumber}
                onChange={handleInputOnChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Codigo Postal"
                name="postalCode"
                value={postalCode}
                onChange={handleInputOnChange}
                variant="outlined"
                error={!!fieldErrors.postalCode}
                helperText={fieldErrors.postalCode}
              />
            </Grid>
            <Grid item xs={12} sm={newCustomerMode ? 12 : 4}>
              <TextField
                fullWidth
                label="Colonia"
                name="colony"
                value={colony}
                onChange={handleInputOnChange}
                variant="outlined"
                error={!!fieldErrors.colony}
                helperText={fieldErrors.colony}
              />
            </Grid>
            <Grid item xs={12} sm={newCustomerMode ? 6 : 4}>
              <TextField
                fullWidth
                label="Municipio"
                name="municipality"
                value={municipality}
                onChange={handleInputOnChange}
                variant="outlined"
                error={!!fieldErrors.municipality}
                helperText={fieldErrors.municipality}
              />
            </Grid>
            <Grid item xs={12} sm={newCustomerMode ? 6 : 4}>
              <TextField
                fullWidth
                label="Estado"
                name="state"
                value={state}
                onChange={handleInputOnChange}
                variant="outlined"
                error={!!fieldErrors.state}
                helperText={fieldErrors.state}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            label="Referencia"
            name="reference"
            value={reference}
            onChange={handleInputOnChange}
            variant="outlined"
            multiline
            error={!!fieldErrors.reference}
            helperText={fieldErrors.reference}
          />
        </Grid>
        {!editCustomer && (
          <>
            <Grid item xs={12}>
              <AutocompleteComponent
                label="Planta"
                name="idStation"
                value={idStation}
                handleValues={handleNewValues}
                options={stationsAvailable}
                textFieldProps={{
                  error: fieldErrors.idStation,
                  helperText: fieldErrors.idStation,
                }}
                disabled={newCustomerMode || addMode ? false : true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <AutocompleteComponent
                label="Tipo"
                name="type"
                value={type}
                customAction={handleUnitType}
                options={typesUnitsOpt.filter(
                  (tUnit) =>
                    tUnit.value === "ESTACIONARIO" || tUnit.value === "PORTATIL"
                )}
                textFieldProps={{
                  error: fieldErrors.type,
                  helperText: fieldErrors.type || "",
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <AutocompleteComponent
                label="Segmento"
                name="segment"
                value={segment}
                handleValues={handleNewValues}
                options={segmentsOpt}
                textFieldProps={{
                  error: fieldErrors.segment,
                  helperText: fieldErrors.segment || "",
                }}
                disabled={type === null}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <AutocompleteComponent
                label="Sub-Segmento"
                value={subsegment}
                name="subsegment"
                handleValues={handleNewValues}
                options={segment?.subsegments}
                textFieldProps={{
                  error: fieldErrors.subsegment,
                  helperText: fieldErrors.subsegment || "",
                }}
                disabled={segment === null}
              />
            </Grid>
            {isGiro && (
              <Grid item xs={12} sm={4}>
                <AutocompleteComponent
                  label="Giro"
                  value={factor}
                  name="factor"
                  handleValues={handleNewValues}
                  options={factorOpt}
                />
              </Grid>
            )}
          </>
        )}
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}
        >
          <RegularButton
            color="danger"
            onClick={newCustomerMode ? onClose : cancelAction}
            disabled={isLoadingComp?.loadingCustomerCrud}
          >
            Cancelar
          </RegularButton>
          <RegularButton
            color="info"
            onClick={handleSubmit}
            loading={isLoadingComp?.loadingCustomerCrud}
          >
            {addMode || newCustomerMode
              ? `Crear ${newCustomerMode ? "Cliente" : ""}`
              : "Guardar"}
          </RegularButton>
        </Grid>
      </Grid>
      <Snackbar
        place="tr"
        open={isOpen}
        color={color}
        message={message}
        close
        closeNotification={clearSnackbar}
      />
    </FormControl>
  );
};
